import React from 'react';

function DotacjaPage() {
  return (
    <div
      style={{
        height: "100vh",
        background: "#fff",
        color: "#333",
        position: "relative",
        padding: "40px 20px",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "60px", maxWidth: "1200px", margin: "0 auto" }}>
        <div style={{ flex: 0, display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
          <img
            src="/images/unia_logo.png"
            alt="UNIA Logo"
            style={{
              width: "800px",
              maxWidth: "90vw",
              height: "auto"
            }}
          />
        </div>

        <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", gap: "60px", width: "100%" }}>
          <div style={{ flex: 1, maxWidth: "1000px" }}>
          <h2 style={{ fontSize: "1.8rem", marginBottom: "20px", color: "#333" }}>O Projekcie</h2>
          <div style={{ lineHeight: "1.8", fontSize: "1rem" }}>
        <p>
          Firma Embertron uzyskała dotację z Unii Europejskiej na projekt „Wsparcie na nowy start”.
        </p>
        <p>
          Projekt realizowany w ramach programu Fundusze Europejskie dla Śląskiego 2021-2027, <br />
          PRIORYTET FESL.10 Fundusze Europejskie na transformację, <br />
          DZIAŁANIE FESL.10.20 Wsparcie na założenie działalności gospodarczej.
        </p>
        <p>
          W ramach projektu przewidziano zestaw instrumentów, mający charakter kompleksowych pakietów działań 
          obejmujący wsparcie szkoleniowe oraz doradcze oferowane na etapie poprzedzającym założenie firmy 
          (szkolenia z zakresu prowadzenia działalności gospodarczej, doradztwo biznesowe) oraz 
          przyznanie środków finansowych na rozpoczęcie działalności gospodarczej.
        </p>
        <p>
            Wartość projektu: 100 000 zł<br />
            Wysokość wkładu z Funduszy Europejskich: 100 000 zł
        </p>
        <p>
          #FunduszeUE #FunduszeEuropejskie
        </p>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}

export default DotacjaPage;
